import { Modal } from 'react-bootstrap';

import { Actionable } from 'root/widgets/common-components';
import { HIVE_STATIC_VERSION } from 'root/widgets/constants';

import { MOBILE_PAGE } from 'root/widgets/mrt-search-modal/constants';
import { HeaderProps } from 'root/widgets/mrt-search-modal/types';
import { SvgIcon } from 'root/widgets/svg-icon';

const isMobileListPage = (page: string) => page === MOBILE_PAGE.LIST;

const Header = ({ modalTitle, sectionTitle, mobilePage, onBack, onClose }: HeaderProps) => (
  <Modal.Header className="mrt-search-modal-header">
    {!isMobileListPage(mobilePage) && (
      <>
        <h4 className="modal-title">{modalTitle}</h4>
        <Actionable className="hui-modal-header-action-btn hui-btn-close" variant="link" onClick={onClose}>
          <SvgIcon
            width={10}
            height={10}
            src={`https://cdn.pgimgs.com/hive-ui/static/${HIVE_STATIC_VERSION}/pg-icons/cancel.svg`}
          />
        </Actionable>
      </>
    )}
    {isMobileListPage(mobilePage) && (
      <Actionable variant="link secondary icon-prefix" onClick={onBack}>
        <i className="pgicon-arrow-left" />
        <span className="header-section-title">{sectionTitle}</span>
      </Actionable>
    )}
  </Modal.Header>
);

Header.displayName = 'Header';

export default Header;
